import { createContext } from 'react';

export default createContext<{
  formValues: { [key: string]: string };
  formErrors: { [key: string]: string[] };
}>({ formValues: {}, formErrors: {} });
